import './style.css'
import * as THREE from 'three'
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js'
import * as dat from 'dat.gui'
import CANNON, { Quaternion, Vec3 } from 'cannon'
import { PointsMaterial, Vector3 } from 'three'
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader'
import { DRACOLoader } from 'three/examples/jsm/loaders/DRACOLoader'
// import { FontLoader } from 'three/examples/jsm/loaders/FontLoader.js'

let textPhysics
let textBodyLet
let nameBody
let nameCannonBody
let boxes
const gltfLoader = new GLTFLoader();
const dracoLoader = new DRACOLoader();
dracoLoader.setDecoderPath( 'draco/' );
gltfLoader.setDRACOLoader(dracoLoader);



/**
 * Debug
 */
// const gui = new dat.GUI()

/**
 * Base
 */
// Canvas
const canvas = document.querySelector('canvas.webgl')

// Scene
const scene = new THREE.Scene()



const fontLoader =  new THREE.FontLoader()
//WORLD
const world = new CANNON.World()
world.gravity.set(0,-9.82, 0)
const textSource = "loremipsumdoloresloremipsumdoloresloremipsumdoloresloremipsumd"
const name = document.querySelector("h1").innerText 
const textArray = textSource.split("")
let createdTextMeshes = []
let createdTextBodies = []

//Materials
const defaultMaterial = new CANNON.Material('default')

const defaultContactMaterial = new CANNON.ContactMaterial(defaultMaterial, defaultMaterial,{
    friction: 1.0,
    restitution: 0.2
})
world.addContactMaterial(defaultContactMaterial)
world.allowSleep = true


// GLTF STARTS TO LOAD
gltfLoader.load(
    'models/gifts2.glb',
    function (gltf){
        boxes = gltf.scene;
        for(var i =1; i<boxes.children.length; i++){
            boxes.children[i].material.envMap = environmentMapTexture
            if(boxes.children[i].material.name == "glass"){
                console.log(boxes.children[i].material);
                boxes.children[i].material.transmission = 0.99
                boxes.children[i].material.roughness = 0
                boxes.children[i].material.reflectivity = 1
                boxes.children[i].material.envMap = environmentMapTexture
            }
        }
        gltf.scene.traverse( function( node ) {

            if ( node.isMesh ) { node.castShadow = false;node.receiveShadow = true }
    
        } );
        scene.add(boxes);
        boxes.position.z = -3
        boxes.position.x = 0
        console.log(boxes);
        boxes.rotation.y = Math.PI *-0.3
        // boxes.scale = new Vector3(0.1,0.1,0.1)
    },
    (xhr) => {
        console.log((xhr.loaded / xhr.total) * 100 + '% loaded')


    },
    (error) => {
        console.log(error)
    }
)

// TEXTGEOMETRIES
            // SNOWFLAKES
            fontLoader.load(
                'fonts/DH Snowflakes_Regular.json',
                (font) => 
                {
                    for(const object of textArray){
                        const textGeometry = new THREE.TextBufferGeometry(
                            object,
                            {
                                font:font,
                                size:0.35,
                                height:0.025,
                                curveSegments: 6,
                                bevelEnabled: false,
                                bevelThickness: 0.03,
                                bevelSize: 0.02,
                                bevelOffset: 0,
                                bevelSegments: 3,
                            }
                        )
                
                        textGeometry.center()
                        textGeometry.castShadow = true;
                        
                        const textMaterial = new THREE.MeshStandardMaterial({
                            color: '#ecdeb9',
                            metalness: 0.3,
                            roughness: 0.4,
                            envMap: environmentMapTexture,
                            
                        })
                        textMaterial.emissive = new THREE.Color(0xffffff)
                        textMaterial.emissiveIntensity = 0
                        const text = new THREE.Mesh(textGeometry, textMaterial)
                        scene.add(text)
                        text.position.y = 3
                        text.position.x = (Math.random()-0.5)*3
                        text.position.z = (Math.random()-0.5)*3
                        createdTextMeshes.push(text)
                        text.castShadow = true
                        
                    }
                    
                    //TEXT
                    for(const object of createdTextMeshes){
                        const textShape = new CANNON.Box(new CANNON.Vec3(object.geometry.boundingBox.max.x,object.geometry.boundingBox.max.y,object.geometry.boundingBox.max.z))
                        const textBody = new CANNON.Body({
                        mass: 1,
                        position: new CANNON.Vec3((Math.random()-0.5)*6, (Math.random())*10.33, (Math.random()-0.5)*3),
                        shape: textShape,
                        material: defaultMaterial
                    })
                    textBody.sleepSpeedLimit = 0.5;
                    world.addBody(textBody)
                    createdTextBodies.push(textBody)
                    
                    }
                    
                    
                },
                // onProgress callback
                function ( xhr ) {
                    console.log( (xhr.loaded / xhr.total * 100) + '% loaded' );
                },
            
                // onError callback
                function ( err ) {
                    console.log( err );
                }
            );

            // NAME TEXT
fontLoader.load(
    'fonts/Santa Claus.json',
    (font) => 
    {
            const textGeometry = new THREE.TextBufferGeometry(
                name,
                {
                    font:font,
                    size:0.5,
                    height:0.9,
                    curveSegments: 6,
                    bevelEnabled: true,
                    bevelThickness: 0.015,
                    bevelSize: 0.02,
                    bevelOffset: 0,
                    bevelSegments: 6,
                }
            )
    
            textGeometry.center()
            
        
            
            const textMaterial = new THREE.MeshStandardMaterial({
                color: '#ecdeb9',
                metalness: 1.0,
                roughness: 0.1,
                envMap: environmentMapTexture,
                
            })
            const newMaterial = new THREE.MeshPhongMaterial({
                color: '#ecdeb9',
                specular: 10,
                envMap: environmentMapTexture
            })
            const text = new THREE.Mesh(textGeometry, newMaterial)
            scene.add(text)
            text.position.y = 3
            text.position.x = 0
            text.position.z = 0
            // createdTextMeshes.push(text)
            nameBody = text;
            text.castShadow = true
            text.receiveShadow = true
            
            const textShape = new CANNON.Box(new CANNON.Vec3(textGeometry.boundingBox.max.x,textGeometry.boundingBox.max.y,textGeometry.boundingBox.max.z))
            const textBody = new CANNON.Body({
            mass: 200,
            torque: new CANNON.Vec3(0.0,-1.0,0.0),
            position: new CANNON.Vec3((Math.random()-0.5), 2.33, (Math.random()-0.5)+1),
            shape: textShape,
            material: defaultMaterial
        })
        textBody.sleepSpeedLimit = 0.5;
        world.addBody(textBody)

        nameCannonBody = textBody
        // createdTextBodies.push(textBody)
    },
    // onProgress callback
	function ( xhr ) {
		console.log( (xhr.loaded / xhr.total * 100) + '% loaded' );
	},

	// onError callback
	function ( err ) {
		console.log( err );
	}
)


// BASE TEXT
fontLoader.load(
    'fonts/Santa Claus.json',
    (font) => 
    {
            const textGeometry = new THREE.TextBufferGeometry(
                "Merry Christmas!",
                {
                    font:font,
                    size:0.5,
                    height:0.2,
                    curveSegments: 6,
                    bevelEnabled: true,
                    bevelThickness: 0.015,
                    bevelSize: 0.02,
                    bevelOffset: 0,
                    bevelSegments: 3,
                }
            )
    
            textGeometry.center()
            
            const textMaterial = new THREE.MeshStandardMaterial({
                color: '#ad242c',
                metalness: 0.9,
                roughness: 0.0,
                envMap: environmentMapTexture,
                
            })
            const text = new THREE.Mesh(textGeometry, textMaterial)
            scene.add(text)
            text.position.y = 4.5
            text.position.x = 0
            text.position.z = 0 
    },
    // onProgress callback
	function ( xhr ) {
		console.log( (xhr.loaded / xhr.total * 100) + '% loaded' );
	},

	// onError callback
	function ( err ) {
		console.log( err );
	}
)

/**
 * Textures
 */
const textureLoader = new THREE.TextureLoader()
const cubeTextureLoader = new THREE.CubeTextureLoader()

const environmentMapTexture = cubeTextureLoader.load([
    '/textures/environmentMaps/0/px.png',
    '/textures/environmentMaps/0/nx.png',
    '/textures/environmentMaps/0/py.png',
    '/textures/environmentMaps/0/ny.png',
    '/textures/environmentMaps/0/pz.png',
    '/textures/environmentMaps/0/nz.png'
])

// PHYSICS




//SPHERE
const sphereShape = new CANNON.Sphere(0.5)
const sphereBody = new CANNON.Body({
    mass: 0.2,
    position: new CANNON.Vec3(0, 3, 0),
    shape: sphereShape,
    material: defaultMaterial
})
world.addBody(sphereBody)

const floorShape = new CANNON.Plane()
const floorBody = new CANNON.Body()
floorBody.mass = 0
floorBody.addShape(floorShape)
floorBody.quaternion.setFromAxisAngle(
    new CANNON.Vec3(-1,0,0),
    Math.PI * 0.5
)
floorBody.material = defaultMaterial
world.addBody(floorBody)

// ////////
const wallBody1 = new CANNON.Body()
wallBody1.mass = 0
wallBody1.addShape(floorShape)
// wallBody1.quaternion.setFromAxisAngle(
//     new CANNON.Vec3(0,0,0),
//     Math.PI * 0.5
// )
wallBody1.material = defaultMaterial
world.addBody(wallBody1)
wallBody1.position.z = -3

// ////////
const wallBody2 = new CANNON.Body()
wallBody2.mass = 0
wallBody2.addShape(floorShape)

wallBody2.material = defaultMaterial
world.addBody(wallBody2)
wallBody2.position.z = 3
wallBody2.quaternion.setFromAxisAngle(
    new CANNON.Vec3(-1,0,0),
    Math.PI * 1
)

// ////////
const wallBody3 = new CANNON.Body()
wallBody3.mass = 0
wallBody3.addShape(floorShape)
// wallBody1.quaternion.setFromAxisAngle(
//     new CANNON.Vec3(0,0,0),
//     Math.PI * 0.5
// )
wallBody3.material = defaultMaterial
world.addBody(wallBody3)

wallBody3.quaternion.setFromAxisAngle(
    new CANNON.Vec3(0,1,0),
    Math.PI * 0.5
)
wallBody3.position.x = -4

// ////////
const wallBody4 = new CANNON.Body()
wallBody4.mass = 0
wallBody4.addShape(floorShape)

wallBody4.material = defaultMaterial
world.addBody(wallBody4)

wallBody4.quaternion.setFromAxisAngle(
    new CANNON.Vec3(0,-1,0),
    Math.PI * 0.5
)
wallBody4.position.x = 4





/**
 * Test sphere
 */
const sphere = new THREE.Points(
    new THREE.SphereBufferGeometry(0.5, 32, 32),
    new THREE.PointsMaterial({size:0.01,visible:false})
)


sphere.castShadow = true
sphere.position.y = 0.5

scene.add(sphere)

/**
 * Floor
 */
const floor = new THREE.Mesh(
    new THREE.PlaneBufferGeometry(100, 100),
    new THREE.MeshStandardMaterial({
        color: '#222222',
        metalness: 0.0,
        roughness: 0.9,
       
        
    })
)
floor.receiveShadow = true
floor.rotation.x = - Math.PI * 0.5
scene.add(floor)
// WALL
const wall1 = new THREE.Mesh(new THREE.PlaneBufferGeometry(10,10),new THREE.MeshBasicMaterial({color:0xff0000}))
// scene.add(wall1)

// FOG

// scene.fog = new THREE.Fog({
//     color: '#ff0000',
//     name: "fog",
//     near:0.01,
//     far: 10.0
// })
const fogColor = new THREE.Color(0x000000)
scene.background = fogColor
scene.fog = new THREE.FogExp2(fogColor, 0.03);

/**
 * Lights
 */
const ambientLight = new THREE.AmbientLight(0xff9999, 0.7)
scene.add(ambientLight)

const directionalLight = new THREE.DirectionalLight(0x9999ff, 1)
directionalLight.castShadow = true
directionalLight.shadow.mapSize.set(1024, 1024)
directionalLight.shadow.camera.far = 15
directionalLight.shadow.camera.left = - 7
directionalLight.shadow.camera.top = 7
directionalLight.shadow.camera.right = 7
directionalLight.shadow.camera.bottom = - 7
directionalLight.position.set(5, 5, 5)
scene.add(directionalLight)

/**
 * Sizes
 */
const sizes = {
    width: window.innerWidth,
    height: window.innerHeight
}

window.addEventListener('resize', () =>
{
    // Update sizes
    sizes.width = window.innerWidth
    sizes.height = window.innerHeight

    // Update camera
    camera.aspect = sizes.width / sizes.height
    camera.updateProjectionMatrix()

    // Update renderer
    renderer.setSize(sizes.width, sizes.height)
    renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))
})

/**
 * Camera
 */
// Base camera
const camera = new THREE.PerspectiveCamera(40, sizes.width / sizes.height, 0.1, 100)
camera.position.set(0, 1, 10)
scene.add(camera)

// Controls
const controls = new OrbitControls(camera, canvas)
controls.enableDamping = true
controls.enablePan = false
controls.enableZoom = false
controls.autoRotate = true
controls.autoRotateSpeed = 0.2

controls.maxAzimuthAngle = Math.PI*0.1
controls.minAzimuthAngle = -Math.PI*0.1
controls.maxPolarAngle = Math.PI*0.55
controls.minPolarAngle = Math.PI*0.45
controls.target = new Vector3(0,2.5,0)
// camera.position.x=0
// camera.position.z=10
// camera.position.z=-30
if(sizes.height>sizes.width){
    camera.fov = 52
    camera.filmGauge = 35
    camera.updateProjectionMatrix();
    console.log(camera);

}

/**
 * Renderer
 */
const renderer = new THREE.WebGLRenderer({
    canvas: canvas,
    antialias: true
})
renderer.shadowMap.enabled = true
renderer.shadowMap.type = THREE.PCFSoftShadowMap
renderer.setSize(sizes.width, sizes.height)
renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))

/**
 * Animate
 */
const clock = new THREE.Clock()
let oldElapsedTime = 0

const tick = () =>
{
    const elapsedTime = clock.getElapsedTime()
    const deltaTime = elapsedTime - oldElapsedTime
    oldElapsedTime = elapsedTime
    //Update Physics World
    world.step(1/60, deltaTime,3)
    sphere.position.copy(sphereBody.position)
    // if(textPhysics!=null){
    //     textPhysics.position.copy(textBodyLet.position)
    //     textPhysics.quaternion.copy(textBodyLet.quaternion)
    // }
    if (createdTextBodies.length>textArray.length-1){
        for(let i = 0; i<createdTextBodies.length; i++){
            createdTextMeshes[i].position.copy(createdTextBodies[i].position)
            createdTextMeshes[i].quaternion.copy(createdTextBodies[i].quaternion)
            // createdTextMeshes[i].rotation.x = Math.PI * -0.5 
        }
        // nameBody.position.copy(nameCannonBody.position)
    }
    if(wallBody4!=null){
        wall1.position.copy(wallBody4.position)
        wall1.quaternion.copy(wallBody4.quaternion)
    }
    if(nameBody!=null&&nameCannonBody!=null){
        nameBody.position.copy(nameCannonBody.position)
        nameBody.quaternion.copy(nameCannonBody.quaternion)
    }
    // Update controls
    controls.update()

    // Render
    renderer.render(scene, camera)
    

    // Call tick again on the next frame
    window.requestAnimationFrame(tick)
}

tick()
